const authRoutes = {
  path: '/auth',
  component: () => import('@/layouts/blank/BlankLayout.vue'),
  meta: {
    requireAuth: false,
  },
  children: [
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/auth/LoginView.vue'),
    },
  ],
}

export default authRoutes
